import type { ReactElement } from 'react';

import {
  BpkExtraLargeSpinner,
  SPINNER_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-spinner';

import STYLES from './LoadingSpinner.module.scss';

const LoadingSpinner = (): ReactElement => (
  <div className={STYLES['spinner-wrapper']}>
    <BpkExtraLargeSpinner type={SPINNER_TYPES.primary} />
  </div>
);

export default LoadingSpinner;
